import { Theme, makeStyles } from "@material-ui/core";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";

const retornarCorStatus = (situacao: EnumStatusTransferencia, theme: Theme): string => {
    switch (situacao) {
        case EnumStatusTransferencia.Aceito:
            return theme.palette.success.light;
        case EnumStatusTransferencia.Abortada:
            return theme.palette.error.light;
        case EnumStatusTransferencia.ErroInterno:
            return theme.palette.error.main;
        case EnumStatusTransferencia.Autorizada:
            return theme.palette.success.main;
        case EnumStatusTransferencia.Pendente:
            return theme.palette.warning.light;
        case EnumStatusTransferencia.Rejeitada:
            return theme.palette.error.dark;
        case EnumStatusTransferencia.ProcessandoEstorno:
            return theme.palette.info.main;
        case EnumStatusTransferencia.Estornada:
            return theme.palette.warning.dark;
        case EnumStatusTransferencia.Expirada:
            return theme.palette.warning.main;
        default:
            return theme.palette.info.light;
    }
}

interface StylesProps {
    status: EnumStatusTransferencia;
}

export const useStyles = makeStyles<Theme, StylesProps>((theme) => ({
    container: {
        width: '100%',
    },
    bottom: {
        display: 'flex',
        padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
        justifyContent: 'flex-end'
    },
    header: {
        padding: `0 ${theme.spacing(3)}px`,
        display: 'flex',
        gap: theme.spacing(2)
    },
    select: {
        marginBottom: theme.spacing(2)
    },
    badgeStatus: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        background: ({ status }) => retornarCorStatus(status, theme),
        borderRadius: theme.shape.borderRadius,
        height: '100%',
        width: 'auto',
        alignSelf: 'center',
        color: ({ status }) => {
            if ([
                EnumStatusTransferencia.Rejeitada,
                EnumStatusTransferencia.Autorizada,
                EnumStatusTransferencia.ProcessandoEstorno,
                EnumStatusTransferencia.Expirada,
            ].includes(status)) {
                return theme.palette.common.white;
            }
            return theme.palette.primary.main
        },
        fontWeight: 500
    }
}));